<template>
  <div class="acdwxlcsg">
    <a @click="clickspan(item)" v-for="(item, index) in items" :key="index" :class="{active:days==item}"
      >{{ item }}日</a
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      time: {
        start: 1,
        end: 2,
      },
      items: [7, 30],
      days:7
    };
  },
  methods: {
    clickspan(v) {
      this.days=v;
      this.calTime();
      this.$emit("startend", this.time);
    },
    calTime(){
      var date=new Date();
      var y=date.getFullYear();
      var m=date.getMonth();
      var d=date.getDate();
      var end=new Date(y,m,d).getTime();
      this.time={
        start:end-86400000*(this.days-1),
        end:end+86400000-1,
      }
    }
  },
  mounted() {
    this.clickspan(this.days);
  },
};
</script>
<style>
.acdwxlcsg {
  display: inline-block;
  float: right;
}
.acdwxlcsg > a {
  margin-left: 6px;
  color: #999;
}
.acdwxlcsg > a.active {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/statrEnd.vue